import { createMutation, createQuery } from 'react-query-kit';

import portalSchema from 'support/types/schema-portal';

import { createData, fetchData, updateData } from '../../http/http';
import { NOTIFICATIONS_MANAGEMENT_QUERY_KEY } from '../queryKeys';

export type GetResponsibleUsersResponse =
  portalSchema.paths['/v1/partners/current/responsible']['get']['responses']['200']['content']['application/json'];

export type UpdateResponsibleUsersRequest =
  portalSchema.paths['/v1/partners/current/responsible']['put']['requestBody']['content']['application/json'];

export type UpdateResponsibleUsersResponse =
  portalSchema.paths['/v1/partners/current/responsible']['put']['responses']['200']['content']['application/json'];

export const useDocumentTypeRecipients = createQuery<GetResponsibleUsersResponse, void, Error>({
  primaryKey: NOTIFICATIONS_MANAGEMENT_QUERY_KEY,
  queryFn: async () => {
    const { data } = await fetchData<GetResponsibleUsersResponse>('/v1/partners/current/responsible');
    return data;
  },
});

export const useUpdateDocumentTypeRecipients = createMutation<
  UpdateResponsibleUsersResponse,
  UpdateResponsibleUsersRequest,
  Error
>({
  mutationFn: async (payload) => {
    const { data } = await updateData<UpdateResponsibleUsersResponse>('/v1/partners/current/responsible', payload);
    return data;
  },
});

type RequestEmailApproveRequest = {
  emails: Array<{ email: string; name?: string }>;
  context: 'responsible-users' | 'invite-team-member';
};

export const useRequestEmailDomainApproval = createMutation<void, RequestEmailApproveRequest, Error>({
  mutationFn: async (payload) => {
    await createData<void>('/v1/partners/current/request-email-approve', payload);
  },
});
